import { render, staticRenderFns } from "./live-tag.vue?vue&type=template&id=ea0fb874&scoped=true"
import script from "./live-tag.vue?vue&type=script&lang=js"
export * from "./live-tag.vue?vue&type=script&lang=js"
import style0 from "./live-tag.vue?vue&type=style&index=0&id=ea0fb874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0fb874",
  null
  
)

export default component.exports